// @flow

import {MAIN_COLUMN_ID} from '../constants';
import type {Column} from '../typedef';

export const isMainColumn = <DataColumn>(column: Column<DataColumn>): boolean => (
    column.fixed && column.columnId === MAIN_COLUMN_ID
);

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
